module.exports = "/_next/static/images/Trend02Visual@2x-80d7023d4e155c825fd8d31323a09e7f.webp";